import type { Schema_Wohnsituation } from 'cpool-schemas';
import { Anschrift } from 'cpool-schemas';

// NOTE: We need to set the default values from the "Anschrift"-schema in the form, otherwise the form contains dirty fields after the initial render
export const prepareWohnsituation = (livingSituation: Schema_Wohnsituation) => {
    const { anschrift, vorherigeAnschrift, ...rest } = livingSituation;
    return {
        ...rest,
        anschrift: anschrift || Anschrift.parse({}),
        vorherigeAnschrift: vorherigeAnschrift || Anschrift.parse({}),
    };
};
